module.exports = __webpack_public_path__ + "static/media/GroupF.1581959c.svg";